import { Component } from '../Component'
import { element } from '../CustomElement'
import { inject } from '../../services/di'
import { icons } from '../../icons/Icons'

import { StorageService } from '../../services/StorageService'
import { UserAgentService } from '../../services/UserAgentService'
import { LocationService } from '../../services/LocationService'
import { i18n } from '../../i18n/I18n'

const FINAL_COUNTDOWN_TIME = 'FINAL_COUNTDOWN_TIME'
const TIME_PERIOD_DAYS = 7

export { FINAL_COUNTDOWN_TIME, TIME_PERIOD_DAYS }

const IMAGE_LINK =
    'https://s3.amazonaws.com/f.wishabi.ca/creative/Distribution/images/20210609-FlippWeb-Install-img_630x658.jpg'

@element('download-app-banner')
export class DownloadAppBanner extends Component<any, any> {
    @inject storageService: StorageService
    @inject location: LocationService
    @inject userAgent: UserAgentService

    state: any = {
        timerId: null,
        isImgLoaded: false,
    }

    onAttach() {
        if (StorageService.getInstance().getItem(FINAL_COUNTDOWN_TIME)) {
            this.countDown()
        }

        const img = document.createElement('img')
        img.setAttribute('src', IMAGE_LINK)
        img.addEventListener('load', () => {
            this.state.isImgLoaded = true
            this.invalidate()
        })
    }

    toggleBanner = (e: any) => {
        const parentElement = document.getElementsByClassName(
            'download-app-banner'
        )[0]
        const isShow = e.currentTarget.getAttribute('aria-show')

        if (isShow === 'true') {
            parentElement.classList.remove('download-app-banner_show')
            e.currentTarget.setAttribute('aria-show', 'false')
            this.countDown()
        } else {
            parentElement.classList.add('download-app-banner_show')
            e.currentTarget.setAttribute('aria-show', 'true')
            clearInterval(this.state.timerId)
        }
    }

    countDown = () => {
        let finishDate = new Date(
            Date.now() + TIME_PERIOD_DAYS * 24 * 60 * 60 * 1000
        ).getTime()
        StorageService.getInstance().setItem(
            FINAL_COUNTDOWN_TIME,
            JSON.stringify(finishDate)
        )

        finishDate =
            StorageService.getInstance().getItem(FINAL_COUNTDOWN_TIME) ||
            finishDate

        const timer = setInterval(function () {
            const now = new Date().getTime()
            const distance = +finishDate - now

            if (distance < 0) {
                clearInterval(timer)
                StorageService.getInstance().removeItem(FINAL_COUNTDOWN_TIME)
                document
                    .getElementsByClassName('download-app-banner')[0]
                    .classList.add('download-app-banner_show')
                document
                    .getElementsByClassName('download-app-banner-button')[0]
                    .setAttribute('aria-show', 'true')
            }
        }, 1000)
        this.state.timerId = timer
    }

    render() {
        const isFrench = this.location.locale === 'fr-ca'
        const isFinalDate =
            StorageService.getInstance().getItem(FINAL_COUNTDOWN_TIME)

        return (
            <div
                class={`download-app-banner ${isFrench ? 'raiseUp' : ''} ${!isFinalDate && this.state.isImgLoaded ? 'download-app-banner_show' : ''}`}
            >
                <button
                    onClick={this.toggleBanner}
                    aria-show={!isFinalDate ? 'true' : 'false'}
                    class="download-app-banner-button"
                >
                    <span class="download-app-banner-btntitle">
                        {i18n('download_btn')}
                    </span>
                    <i class="download-app-banner-arrow">{icons.downArrow}</i>
                </button>
                <div
                    style={{ backgroundImage: `url("${IMAGE_LINK}")` }}
                    class={`download-app-banner-container ${isFrench ? 'removeIndentation' : ''}`}
                >
                    <span
                        class={`${!isFrench ? 'download-app-banner-title' : this.userAgent.safari ? 'download-app-banner-title_fr-safari' : 'download-app-banner-title_fr'}`}
                    >
                        {i18n('download_app_banner_title')}
                    </span>
                </div>
            </div>
        )
    }
}
